import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { removeCartSkeleton } from './cart-item'

const CartEmpty = ({ ctaText,
  ctaLink,
  message,
  messageSecond,
  wrapperClass,
  messageClassname,
  messageSecondClassname,
  cartPage
}) => {
  useEffect(() => {
    removeCartSkeleton()
  })
  return (
    <div className={`${wrapperClass ? wrapperClass : 'lg:py-32 px-12 py-10 text-grey-2A'}`}>
      {!!message?.length && (
        <div
          className={`${messageClassname ? messageClassname : 'mb-10 lg:mb-32 text-center text-grey-2A'}`}
          data-target="text-content"
          dangerouslySetInnerHTML={{ __html: message }}
        ></div>
      )}
      {!!messageSecond?.length && cartPage && (
        <div
          className={`${messageSecondClassname ? messageSecondClassname : 'mb-10 lg:mb-32 text-center text-grey-2A'}`}
          data-target="text-content"
          dangerouslySetInnerHTML={{ __html: messageSecond }}
        ></div>
      )}
      {!!ctaText && !!ctaLink && !cartPage && (
        <a className="justify-center w-full button button-primary" href={ctaLink}>
          {ctaText}
        </a>
      )}
    </div>
  );
}

export default CartEmpty;
